import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgReload = (props) => /* @__PURE__ */ _jsx("svg", {
	preserveAspectRatio: "none",
	width: "100%",
	height: "100%",
	overflow: "visible",
	style: { display: "block" },
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		id: "icon",
		children: /* @__PURE__ */ _jsx("path", {
			id: "fill color",
			d: "M18.125 0C18.6428 2.26323e-08 19.0625 0.419733 19.0625 0.9375V4.375C19.0625 5.41053 18.223 6.25 17.1875 6.25H13.75C13.2322 6.25 12.8125 5.83027 12.8125 5.3125C12.8125 4.79473 13.2322 4.375 13.75 4.375H15.8623C14.3829 2.83344 12.3033 1.875 10 1.875C5.51269 1.875 1.875 5.51269 1.875 10C1.875 14.4873 5.51269 18.125 10 18.125C14.4873 18.125 18.125 14.4873 18.125 10C18.125 9.48223 18.5447 9.0625 19.0625 9.0625C19.5803 9.0625 20 9.48223 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C6.30295e-09 4.47715 4.47715 0 10 0C12.8222 0 15.3701 1.1702 17.1875 3.04883V0.9375C17.1875 0.419733 17.6072 -2.26323e-08 18.125 0Z",
			fill: "var(--fill-0, #111111)"
		})
	})
});
export default SvgReload;
